module.exports = __webpack_public_path__ + "static/media/logo.3a1daff5.png";